import { Link } from 'react-router'
import type { AppSummary } from '../api/types'

export function AppIcon({ url, size = 'normal' }: { url: string | null; size?: 'normal' | 'large' }) {
	return url ? (
		<img className={`app-icon ${size === 'large' ? 'large' : ''}`} src={url} alt="" loading="lazy" />
	) : (
		<span className={`app-icon ${size === 'large' ? 'large' : ''}`} aria-hidden />
	)
}

export function AppCell({ app }: { app: AppSummary }) {
	return (
		<Link to={`/apps/${app.id}`} className="app-cell" target="_blank" rel="noopener">
			<AppIcon url={app.iconUrl} />
			<span style={{ minWidth: 0 }}>
				<span className="name truncate" style={{ display: 'block' }}>
					{app.name}
				</span>
				<span className="muted small truncate" style={{ display: 'block' }}>
					{app.developerName ?? '—'}
				</span>
			</span>
		</Link>
	)
}
